import {
    Backdrop, Box, Button, CardContent, Fade, FormControl, FormControlLabel, FormGroup, InputLabel, Modal,
    Select, Switch, TextField, Typography
} from '@material-ui/core';
import {
    ACLASSE_TIPO_VEIC_AUTOMOVEL, ACLASSE_TIPO_VEIC_CAMINHAO, ACLASSE_TIPO_VEIC_CAVALOMECANICO,
    ACLASSE_TIPO_VEIC_EMPILHADEIRA, ACLASSE_TIPO_VEIC_MAQUINA, ACLASSE_TIPO_VEIC_MOTOCICLETA,
    ACLASSE_TIPO_VEIC_NENHUM, ACLASSE_TIPO_VEIC_ONIBUS, ACLASSE_TIPO_VEIC_REBOQUE_SEMIREBOQUE,
    ACLASSE_TIPO_VEIC_SUPERDIMENSIONADO, ACLASSE_TIPO_VEIC_UTILITARIO, ANAO, ASIM
} from '../../../consts';
import api from '../../../services/api';
import React, { Component } from 'react';
import { validateField } from 'lib/functions';
import AlertInformation from 'components/AlertInformation/AlertInformation';
import { CloudUploadOutlined as CloudUploadOutlinedIcon } from '@material-ui/icons';
import DeleteConfirmationModal from 'components/DeleteConfirmationModal/DeleteConfirmationModal';

class TipoVeiculoForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            imagemPreview: '',
            imagemNome: '',
            imagemFile: null,
            isDragOver: false,
            removeFoto: false,
            isLoadingTipoVeiculo: true,
            isImageModalOpen: false,
            isNewRecord: false,
            isView: false,
            openRemoveImageModal: false,
            errors: {},
            tipoveiculo: {
                codtipoveiculo: '',
                desctipoveiculo: '',
                capacidadepax: '',
                obs: '',
                classe: 0,
                inativo: ANAO
            },
            schema: {
                desctipoveiculo: {
                    presence: { allowEmpty: false, message: 'Descrição do tipo obrigatória' },
                    length: { maximum: 64 },
                    type: 'string'
                },
                capacidadepax: {
                    presence: { allowEmpty: false, message: 'Capacidade pax obrigatória' },
                    length: { maximum: 64 },
                    type: 'integer'
                }
            }
        };
    };

    async componentDidMount() {
        const { id } = this.props.match.params;
        const { location } = this.props;
        const currentPath = location.pathname;
        const { tipoveiculo } = this.state;

        if (id && id !== 'novo') {
            try {
                const response = await api.get(`/tipoveiculo/${id}`);
                const registros = Array.isArray(response.data) ? response.data : (response.data?.data || []);
                const dados = registros[0] || {};

                console.log('DADOS RECEBIDOS DO BACKEND:', JSON.stringify(dados, null, 2));

                if (!dados.codtipoveiculo) {
                    this.handleOpenAlert('Tipo de veículo não encontrado!');
                    this.setState({ isLoadingTipoVeiculo: false });
                    return;
                }

                this.setState({
                    tipoveiculo: {
                        ...dados,
                        obs: dados.obs || '',
                        classe: dados.classe ?? ACLASSE_TIPO_VEIC_NENHUM,
                        inativo: dados.inativo || ANAO
                    },
                    isNewRecord: false,
                    isView: currentPath.includes('/view'),
                    isLoadingTipoVeiculo: false,
                    removeFoto: false,
                    imagemPreview: dados.foto || '',
                    imagemNome: ''
                });
            } catch (error) {
                console.error('Erro ao carregar:', error);
                this.handleOpenAlert('Erro ao carregar tipo de veículo!');
                this.setState({ isLoadingTipoVeiculo: false });
            }
        } else {
            this.setState({
                isNewRecord: true,
                isView: false,
                isLoadingTipoVeiculo: false,
                removeFoto: false,
                tipoveiculo: {
                    ...tipoveiculo,
                    obs: '',
                    classe: ACLASSE_TIPO_VEIC_NENHUM,
                    inativo: ANAO
                }
            });
        }
    };

    /* Evento on change componentes */
    OnChange = (event) => {
        const { name, type, value, checked } = event.target;

        if (name === 'obs') {
            this.setState(prev => ({
                tipoveiculo: {
                    ...prev.tipoveiculo,
                    [name]: value
                }
            }));
            return;
        }

        let adjustedValue;

        if (type === 'checkbox') {
            adjustedValue = checked ? ANAO : ASIM;
        } else if (name === 'classe') {
            adjustedValue = Number(value);
        } else if (name === 'capacidadepax') {
            adjustedValue = value.replace(/\D/g, '');
        } else {
            adjustedValue = typeof value === 'string' ? value.toUpperCase() : value;
        }

        this.setState(prev => ({
            tipoveiculo: {
                ...prev.tipoveiculo,
                [name]: adjustedValue
            }
        }));
    };

    /* Processa arquivo selecionado/arrastado */
    handleSelectedFile = (file, callback) => {
        if (!file) return;

        const reader = new FileReader();
        reader.onloadend = () => {
            this.setState({
                imagemPreview: reader.result,
                imagemFile: file,
                imagemNome: file.name,
                removeFoto: false,
                isDragOver: false
            }, () => {
                if (callback) callback();
            });
        };
        reader.readAsDataURL(file);
    };

    /* Método para upload via input */
    handleImageChange = (event) => {
        const input = event.target;
        const file = input.files[0];

        this.handleSelectedFile(file, () => {
            input.value = '';
        });
    };

    /* Drag and drop */
    handleDragEnter = (event) => {
        event.preventDefault();
        event.stopPropagation();

        if (!this.state.isView) {
            this.setState({ isDragOver: true });
        }
    };

    /* Método para arrastar */
    handleDragOver = (event) => {
        event.preventDefault();
        event.stopPropagation();

        if (!this.state.isView && !this.state.isDragOver) {
            this.setState({ isDragOver: true });
        }
    };

    /* Método para arrastar e sair */
    handleDragLeave = (event) => {
        event.preventDefault();
        event.stopPropagation();

        if (!event.currentTarget.contains(event.relatedTarget)) {
            this.setState({ isDragOver: false });
        }
    };

    /* Método para soltar arquivo */
    handleDrop = (event) => {
        event.preventDefault();
        event.stopPropagation();

        if (this.state.isView) {
            this.setState({ isDragOver: false });
            return;
        }

        const file = event.dataTransfer?.files?.[0];
        this.handleSelectedFile(file);
    };

    /* Método para apagar imagem (caso necessário) */
    handleRemoveImage = () => {
        this.setState(prev => ({
            imagemPreview: '',
            imagemFile: null,
            imagemNome: '',
            removeFoto: true,
            tipoveiculo: {
                ...prev.tipoveiculo,
                foto: ''
            }
        }));
    };

    /* Métodos para abrir e fechar o Modal */
    handleOpenImageModal = () => {
        this.setState({ isImageModalOpen: true });
    };

    handleCloseImageModal = () => {
        this.setState({ isImageModalOpen: false });
    };

    /* Métodos para confirmar remoção de imagem */
    handleOpenRemoveImageModal = () => {
        this.setState({ openRemoveImageModal: true });
    };

    handleCloseRemoveImageModal = () => {
        this.setState({ openRemoveImageModal: false });
    };

    confirmRemoveImage = () => {
        this.setState({ openRemoveImageModal: false }, () => {
            this.handleRemoveImage();
        });
    };

    /* Abre janela de alerta com mensagem */
    handleOpenAlert = (message) => {
        this.setState({ openAlert: true });
        this.setState({ messageAlert: message });
    };

    /* Fecha janela mensagem alerta */
    handleCloseAlert = () => {
        this.setState({ openAlert: false });
    };

    /* Click salvar */
    onClickSave = async () => {
        const { tipoveiculo, imagemFile, isNewRecord, removeFoto } = this.state;
        let errors = this.validationRequiredFields();
        this.setState({ errors });

        if (Object.keys(errors).length > 0) {
            this.handleOpenAlert('Verifique os campos obrigatórios!');
            return;
        }

        try {
            const formData = new FormData();

            const codusuarioregistrou = sessionStorage.getItem('codUser') || localStorage.getItem('codUser');
            if (!codusuarioregistrou) {
                console.error('Erro: código do usuário não encontrado!');
                return;
            }

            // usa-se quando há campos do tipo BLOB
            formData.append('desctipoveiculo', tipoveiculo.desctipoveiculo || '');
            formData.append('capacidadepax', tipoveiculo.capacidadepax || '');
            formData.append('classe', tipoveiculo.classe !== undefined ? tipoveiculo.classe : 0);
            formData.append('obs', tipoveiculo.obs || '');
            formData.append('inativo', tipoveiculo.inativo || '');
            formData.append('codusuarioregistrou', Number(codusuarioregistrou));
            formData.append('removefoto', removeFoto ? ASIM : ANAO);

            if (imagemFile) {
                formData.append('foto', imagemFile);
            }

            if (isNewRecord) {
                await api.post('/tipoveiculo', formData, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                });
            } else {
                await api.put(`/tipoveiculo/${tipoveiculo.codtipoveiculo}`, formData, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                });
            }

            if (this.props.loadTiposVeiculo) this.props.loadTiposVeiculo();
            this.props.history.push('/frotas/tipoveiculo');

        } catch (error) {
            console.error('Erro ao salvar:', error.response?.data || error.message);
            this.handleOpenAlert(error.response?.data?.error || 'Erro ao salvar!');
        }
    };

    /* Click cancelar */
    onClickCancel = () => {
        this.props.history.push('/frotas/tipoveiculo');
    };

    /* Valida campos obrigatórios ao salvar */
    validationRequiredFields() {
        const { schema, tipoveiculo } = this.state;
        let errors = {};

        // valida campos do schema
        const requiredFields = [
            'desctipoveiculo',
            'capacidadepax'
        ];

        requiredFields.forEach(field => {
            const error = validateField(field, tipoveiculo[field], schema);
            if (error) {
                errors[field] = error;
            }
        })

        return errors;
    };

    render() {
        const {
            errors,
            imagemPreview,
            imagemNome,
            isDragOver,
            isImageModalOpen,
            isLoadingTipoVeiculo,
            isView,
            messageAlert,
            openAlert,
            openRemoveImageModal,
            tipoveiculo
        } = this.state;

        const hasImage = !!imagemPreview;
        const insertButtonLabel = hasImage ? 'Inserir Outro Arquivo' : 'Inserir Arquivo';
        const borderColor = isDragOver ? '#1976d2' : hasImage ? '#66bb6a' : '#bdbdbd';
        const backgroundColor = isDragOver ? '#e3f2fd' : hasImage ? '#edf7ed' : '#f5f5f5';
        const infoTextColor = hasImage ? '#2e7d32' : '#616161';
        const buttonColor = hasImage ? '#43a047' : undefined;
        const buttonTextColor = hasImage ? '#fff' : undefined;

        if (isLoadingTipoVeiculo) {
            return (
                <CardContent>
                    <Typography variant="body1">Carregando tipo de veículo...</Typography>
                </CardContent>
            );
        }

        return (
            <div>
                <CardContent>
                    <Box
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                        flexWrap="wrap"
                        style={{ gap: 12 }}
                    >
                        <Typography
                            component="h1"
                            variant="h3"
                        >
                            Tipo de veículo {tipoveiculo.codtipoveiculo || ''}
                        </Typography>

                        <FormControlLabel
                            label={(tipoveiculo.inativo === ASIM) ? 'Inativo' : 'Ativo'}
                            control={
                                <Switch
                                    checked={!(tipoveiculo.inativo === ASIM)}
                                    name="inativo"
                                    onChange={this.OnChange}
                                    color="primary"
                                    disabled={isView}
                                />
                            }
                        />
                    </Box>

                    <br />

                    <TextField
                        label="Descrição"
                        name="desctipoveiculo"
                        value={tipoveiculo.desctipoveiculo || ''}
                        variant="outlined"
                        onChange={this.OnChange}
                        helperText={errors.desctipoveiculo || ''}
                        error={!!errors.desctipoveiculo}
                        disabled={isView}
                        inputProps={{ maxLength: 50 }}
                        style={{
                            marginTop: '10px',
                            width: '100%'
                        }}
                    />

                    <br />

                    <Box
                        display="flex"
                        flexWrap="wrap"
                        width="100%"
                        style={{
                            marginTop: '17px',
                            gap: 12
                        }}
                    >
                        <FormControl
                            variant="filled"
                            disabled={isView}
                            style={{
                                flex: '1 1 280px',
                                minWidth: 240
                            }}
                        >
                            <InputLabel
                                htmlFor="outlined-age-native-simple"
                                shrink={true}
                                style={{ padding: '0 4px' }}
                            >
                                Classe de Veículo
                            </InputLabel>

                            <Select
                                label="Classe de Veículo"
                                native
                                onChange={this.OnChange}
                                value={String(tipoveiculo.classe ?? ACLASSE_TIPO_VEIC_NENHUM)}
                                inputProps={{
                                    id: 'outlined-age-native-simple',
                                    name: 'classe'
                                }}
                            >
                                <option
                                    key={ACLASSE_TIPO_VEIC_NENHUM}
                                    value={ACLASSE_TIPO_VEIC_NENHUM}
                                >
                                    {"Nenhum"}
                                </option>

                                <option
                                    key={ACLASSE_TIPO_VEIC_CAMINHAO}
                                    value={ACLASSE_TIPO_VEIC_CAMINHAO}
                                >
                                    {"Caminhão"}
                                </option>

                                <option
                                    key={ACLASSE_TIPO_VEIC_AUTOMOVEL}
                                    value={ACLASSE_TIPO_VEIC_AUTOMOVEL}
                                >
                                    {"Automóvel"}
                                </option>

                                <option
                                    key={ACLASSE_TIPO_VEIC_UTILITARIO}
                                    value={ACLASSE_TIPO_VEIC_UTILITARIO}
                                >
                                    {"Utilitário"}
                                </option>

                                <option
                                    key={ACLASSE_TIPO_VEIC_ONIBUS}
                                    value={ACLASSE_TIPO_VEIC_ONIBUS}
                                >
                                    {"Ônibus"}
                                </option>

                                <option
                                    key={ACLASSE_TIPO_VEIC_REBOQUE_SEMIREBOQUE}
                                    value={ACLASSE_TIPO_VEIC_REBOQUE_SEMIREBOQUE}
                                >
                                    {"Reboque/semirreboque"}
                                </option>

                                <option
                                    key={ACLASSE_TIPO_VEIC_EMPILHADEIRA}
                                    value={ACLASSE_TIPO_VEIC_EMPILHADEIRA}
                                >
                                    {"Empilhadeira"}
                                </option>

                                <option
                                    key={ACLASSE_TIPO_VEIC_MOTOCICLETA}
                                    value={ACLASSE_TIPO_VEIC_MOTOCICLETA}
                                >
                                    {"Motocicleta"}
                                </option>

                                <option
                                    key={ACLASSE_TIPO_VEIC_MAQUINA}
                                    value={ACLASSE_TIPO_VEIC_MAQUINA}
                                >
                                    {"Máquina"}
                                </option>

                                <option
                                    key={ACLASSE_TIPO_VEIC_SUPERDIMENSIONADO}
                                    value={ACLASSE_TIPO_VEIC_SUPERDIMENSIONADO}
                                >
                                    {"Superdimensionado"}
                                </option>

                                <option
                                    key={ACLASSE_TIPO_VEIC_CAVALOMECANICO}
                                    value={ACLASSE_TIPO_VEIC_CAVALOMECANICO}
                                >
                                    {"Cavalo mecânico"}
                                </option>
                            </Select>
                        </FormControl>

                        <TextField
                            label="Capacidade pax"
                            name="capacidadepax"
                            value={tipoveiculo.capacidadepax || ''}
                            variant="outlined"
                            disabled={isView}
                            type="number"
                            error={!!errors.capacidadepax}
                            helperText={errors.capacidadepax || ''}
                            inputProps={{ min: 1 }}
                            style={{
                                flex: '1 1 220px',
                                minWidth: 220
                            }}
                            onChange={this.OnChange}
                        />
                    </Box>

                    <br />

                    <Typography
                        color="textSecondary"
                        component="p"
                        variant="body2"
                    >
                        Observação
                    </Typography>

                    <FormGroup>
                        <textarea
                            id="obs"
                            name="obs"
                            onChange={this.OnChange}
                            value={tipoveiculo.obs || ''}
                            disabled={isView}
                            style={{
                                width: '100%',
                                minHeight: '100px',
                                padding: '8px',
                                border: '1px solid #ccc',
                                borderRadius: '4px',
                                fontFamily: 'Calibri, sans-serif',
                                boxSizing: 'border-box'
                            }}
                        />
                    </FormGroup>

                    <Box
                        display="flex"
                        flexWrap="wrap"
                        alignItems="flex-start"
                        style={{
                            gap: 16,
                            marginTop: 16
                        }}
                    >
                        <Box style={{ width: '100%' }}>
                            <Typography
                                color="textSecondary"
                                component="p"
                                variant="body2"
                            >
                                Imagem
                            </Typography>

                            <Box
                                onDragEnter={this.handleDragEnter}
                                onDragOver={this.handleDragOver}
                                onDragLeave={this.handleDragLeave}
                                onDrop={this.handleDrop}
                                style={{
                                    width: '100%',
                                    minHeight: 260,
                                    border: `2px dashed ${borderColor}`,
                                    borderRadius: 12,
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    backgroundColor: backgroundColor,
                                    marginTop: 8,
                                    padding: '24px 20px',
                                    boxSizing: 'border-box',
                                    transition: 'all 0.2s ease-in-out'
                                }}
                            >
                                <CloudUploadOutlinedIcon
                                    style={{
                                        fontSize: 42,
                                        color: hasImage ? '#43a047' : '#90a4ae',
                                        marginBottom: 12
                                    }}
                                />

                                <Typography
                                    variant="body1"
                                    style={{
                                        color: '#424242',
                                        textAlign: 'center',
                                        marginBottom: 6
                                    }}
                                >
                                    {hasImage ? 'Arquivo selecionado' : 'Arraste um arquivo aqui ou selecione um no botão abaixo'}
                                </Typography>

                                {imagemNome ? (
                                    <Typography
                                        variant="caption"
                                        style={{
                                            display: 'block',
                                            marginBottom: 16,
                                            color: infoTextColor,
                                            textAlign: 'center',
                                            wordBreak: 'break-word'
                                        }}
                                    >
                                        Arquivo: {imagemNome}
                                    </Typography>
                                ) : null}

                                <Button
                                    component="label"
                                    variant="contained"
                                    color={!hasImage ? "primary" : undefined}
                                    disabled={isView}
                                    style={{
                                        textTransform: 'none',
                                        minWidth: 190,
                                        ...(hasImage && {
                                            backgroundColor: '#43a047',
                                            color: '#fff'
                                        })
                                    }}
                                >
                                    {insertButtonLabel}
                                    <input
                                        accept="*/*"
                                        style={{ display: 'none' }}
                                        id="upload-imagem-tipo-veiculo"
                                        type="file"
                                        onChange={this.handleImageChange}
                                    />
                                </Button>
                            </Box>

                            <Box
                                display="flex"
                                justifyContent="flex-end"
                                style={{
                                    marginTop: 10,
                                    gap: 10,
                                    width: '100%'
                                }}
                            >
                                <Button
                                    variant="contained"
                                    onClick={this.handleOpenRemoveImageModal}
                                    disabled={!imagemPreview || isView}
                                    style={{ textTransform: 'none' }}
                                >
                                    Remover
                                </Button>

                                <Button
                                    variant="contained"
                                    color="secondary"
                                    onClick={this.handleOpenImageModal}
                                    disabled={!imagemPreview}
                                    style={{ textTransform: 'none' }}
                                >
                                    Visualizar
                                </Button>
                            </Box>
                        </Box>
                    </Box>

                    <br />
                    <br />

                    <Box
                        display="flex"
                        style={{
                            flexWrap: 'wrap',
                            gap: 12,
                            marginTop: 20
                        }}
                    >
                        <Button
                            name="salvar"
                            color="primary"
                            variant="contained"
                            onClick={this.onClickSave}
                            disabled={isView}
                        >
                            Salvar
                        </Button>

                        <Button
                            name="cancelar"
                            variant="contained"
                            onClick={this.onClickCancel}
                            color="secondary"
                        >
                            Cancelar
                        </Button>
                    </Box>

                    <AlertInformation
                        open={openAlert}
                        handleClose={() => this.handleCloseAlert()}
                        message={messageAlert}
                    />

                    <DeleteConfirmationModal
                        open={openRemoveImageModal}
                        handleClose={this.handleCloseRemoveImageModal}
                        itemId=""
                        message="Confirma remoção do arquivo de imagem inserido?"
                        handleDelete={this.confirmRemoveImage}
                    />

                    <Modal
                        open={isImageModalOpen}
                        onClose={this.handleCloseImageModal}
                        closeAfterTransition
                        BackdropComponent={Backdrop}
                        BackdropProps={{ timeout: 500 }}
                    >
                        <Fade in={isImageModalOpen}>
                            <div
                                style={{
                                    position: 'absolute',
                                    top: '50%',
                                    left: '50%',
                                    transform: 'translate(-50%, -50%)',
                                    width: '90vw',
                                    height: '85vh',
                                    maxWidth: 1040,
                                    maxHeight: 585,
                                    backgroundColor: 'transparent',
                                    borderRadius: 12,
                                    boxShadow: 'none',
                                    border: 'none',
                                    outline: 'none',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    padding: 0
                                }}
                            >
                                <img
                                    src={imagemPreview}
                                    alt="Imagem expandida"
                                    style={{
                                        maxWidth: '100%',
                                        maxHeight: '100%',
                                        borderRadius: '8px',
                                        objectFit: 'contain'
                                    }}
                                />
                            </div>
                        </Fade>
                    </Modal>
                </CardContent>
            </div >
        );
    }
}

export default TipoVeiculoForm;